module.exports = __webpack_public_path__ + "assets/img/36_538_big.c29ba64a.jpg";